import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { getReasons } from '../../service/service';

import type { Column } from 'react-data-grid';
import { CustomizedDataGrid } from '../customized_data_grid';
import '../reasonsOfSLA/reasonsOfSLA.css';
import Loader from '../Loader/loader';

export default function ReasonsOfSLA() {
	interface Row {
		id: string;
		reasonCode: string;
		reasonForDelay: string;
	}
	function getColumns(): Array<Column<Row>> {
		return [
			{
				key: 'code',
				name: 'Reason Code',
				minWidth: 185
				// editor: textEditor
			},
			{
				key: 'description',
				name: 'Reason for delay',
				minWidth: 170
			}
		];
	}
	// Default view option in three dots
	const defaultColumnNames = ['Reason Code', 'Reason for delay'];

	const [reasonsList, setResonsList] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);

	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		sectorListingFunc(value, pageSize, sortingInfo);
	};

	const handlepageSizeChange = (event: any) => {
		sectorListingFunc(page, event.target.value, sortingInfo);
	};

	useEffect(() => {
		sectorListingFunc(page, pageSize, sortingInfo);
	}, []);

	async function sectorListingFunc(pageNumber: any, size: any, sortingInfo: any) {
		const res = await getReasons(pageNumber.toString(), size.toString(), sortingInfo);
		console.log(res, 'response of sla');
		if (res.success) {
			setResonsList(res.data.slaNotMetReasons);
			setPaginationData(res.data.page);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
		}
	}
	const handleSorting = (sortingInfo: any) => {
		sectorListingFunc(page, pageSize, sortingInfo);
	};

	return (
		<div className="page-table reasonOfSLA_tabledata">
			<Grid>
				{reasonsList.length > 0 ? (
					<CustomizedDataGrid
						tableColumns={getColumns()}
						tableData={reasonsList}
						tableType="reasonsOfSLA"
						defaultColumnNames={defaultColumnNames}
						onSorting={handleSorting}
						currSorting={sortingInfo}
						page={page}
						pageSize={pageSize}
						paginationData={paginationData}
						listLength={reasonsList.length}
						handlepageSizeChange={handlepageSizeChange}
						handlePageChange={handlePageChange}
						isDateRangeFilter={false}
						isDisabled={false}
					/>
				) : (
					<Loader />
				)}
			</Grid>
		</div>
	);
}
